import { useQuery } from '@tanstack/react-query';
import { concat } from 'lodash';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

import { mapScheduleAssemblies } from '../helper';

export const useGetScheduleAssemblies = (
  filters: string[] = [],
  enabled = true,
  rbStoreIntegration?: boolean,
) => {
  return useQuery({
    queryKey: queryKeys.scheduleAssemblies.all(filters),
    queryFn: () => fetchScheduleAssemblies(filters, rbStoreIntegration),
    enabled,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};

export const fetchScheduleAssemblies = async (
  filters: string[] = [],
  rbStoreIntegration?: boolean,
) => {
  const url = `/scheduleAssemblies${generateQuery(
    rbStoreIntegration ? ['assemblies'] : ['assemblies', 'dayparts'],
    concat(filters, 'pageSize=0'),
  )}`;

  const response = await requestCCApi({ url });

  return mapScheduleAssemblies(response);
};
